"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Card = _interopRequireDefault(require("../../../Card"));
var _Button = _interopRequireDefault(require("../../../../Button/Button"));
var _Carousel = _interopRequireDefault(require("../../../../Carousel/Carousel"));
var _Pill = _interopRequireDefault(require("../../../../Pill/Pill"));
var _Svg = _interopRequireDefault(require("../../../../Svg/Svg"));
var _Modal = _interopRequireDefault(require("../../../../Modal"));
var _Toggle = _interopRequireDefault(require("../../../../helpers/Toggle"));
var _constants = require("../../../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var VerticalSplit = function VerticalSplit(_ref) {
  var size = _ref.size,
    heading = _ref.heading,
    subheading = _ref.subheading,
    cta = _ref.cta,
    image = _ref.image,
    title = _ref.title,
    mainTitle = _ref.mainTitle,
    noJustifyEnd = _ref.noJustifyEnd,
    children = _ref.children,
    titleSize = _ref.titleSize,
    video = _ref.video,
    fullHeight = _ref.fullHeight,
    carouselImages = _ref.carouselImages,
    pills = _ref.pills,
    pillComponent = _ref.pillComponent,
    inView = _ref.inView,
    imagePadding = _ref.imagePadding,
    gallery = _ref.gallery;
  var PillComponent = function PillComponent() {
    return pillComponent();
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('image--vertical-split', 'flex', 'flex-column', {
      'justify-end': !noJustifyEnd,
      'height-100%': fullHeight
    })
  }, carouselImages ? /*#__PURE__*/_react["default"].createElement(_Carousel["default"], {
    template: "Children",
    arrowsInner: true,
    settings: {
      arrows: true,
      dots: false
    }
  }, carouselImages.map(function (i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: (0, _classnames["default"])('d8-u-relative', 'height-100%', 'vertical-split__top', size === 'xl' && 'aspect-1-1', size === 'xs' && 'aspect-16-9', size === 'md' && 'aspect-3-2')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-right padding-right-md width-100%",
      style: {
        position: 'absolute',
        zIndex: 2,
        top: 10
      }
    }, pills.map(function (pill) {
      return /*#__PURE__*/_react["default"].createElement(_Pill["default"], {
        key: JSON.stringify(pill),
        pill: pill
      });
    }), pillComponent && /*#__PURE__*/_react["default"].createElement(PillComponent, null)), /*#__PURE__*/_react["default"].createElement("img", {
      alt: "Carousel",
      className: "d8-u-radius-md-top",
      src: inView ? i : ''
    }));
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: imagePadding && 'padding-xxs'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('d8-u-relative', 'height-100%', 'd8-u-bg-img', 'vertical-split__top', size === 'xl' && 'aspect-1-1', size === 'xs' && 'aspect-16-9', size === 'md' && 'aspect-3-2', imagePadding && 'd8-u-radius-md d8-u-shadow-sm'),
    role: image && image.url && 'img',
    "aria-label": image && image.alt || title,
    style: {
      backgroundImage: "url(".concat(inView && image ? image.url : '', ")")
    }
  }, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, pills && pills.length > 0 && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title__wrapper padding-x-md padding-top-sm flex items-start justify-end"
  }, pills.map(function (pill) {
    return /*#__PURE__*/_react["default"].createElement(_Pill["default"], (0, _extends2["default"])({
      key: JSON.stringify(pill),
      className: "margin-x-xs"
    }, pill));
  }))), pillComponent && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title__wrapper padding-x-md padding-top-sm flex items-start justify-end"
  }, /*#__PURE__*/_react["default"].createElement(PillComponent, null))), video && /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref2) {
    var on = _ref2.on,
      toggle = _ref2.toggle;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "absolute-center text-center"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: toggle,
      buttonType: _constants.BUTTON_TYPES.BARE_WHITE
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      name: "play",
      onClick: toggle,
      className: "icon--xl"
    }))), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      video: video,
      toggle: toggle,
      on: on,
      template: "Video"
    }));
  }), gallery && /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref3) {
    var on = _ref3.on,
      toggle = _ref3.toggle;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "gallery"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "gallery-button",
      buttonType: _constants.BUTTON_TYPES.CIRCLE_ICON_GHOST,
      icon: "images",
      onClick: toggle
    }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      toggle: toggle,
      on: on,
      noPadding: true
    }, /*#__PURE__*/_react["default"].createElement(_Carousel["default"], {
      className: "d8-c-carousel-contrast",
      arrowsInner: true,
      settings: {
        infinite: false,
        arrows: true,
        dots: true
      }
    }, gallery.map(function (i) {
      return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        key: JSON.stringify(i),
        template: "ImageCard",
        size: "aspect-16-9",
        bgImage: {
          url: i.url,
          alt: i.alt
        },
        whiteFont: true,
        overlay: true
      });
    }))));
  })), title && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-overlay d8-u-radius-md-top"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "title__wrapper d8-u-component-padding flex items-end"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "d8-u-color-white ".concat(titleSize || 'text-xl')
  }, title))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('vertical-split__bottom', 'd8-u-component-padding', {
      'height-100%': fullHeight
    })
  }, !children ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, heading && /*#__PURE__*/_react["default"].createElement("h4", {
    className: (0, _classnames["default"])('card--image__heading', 'text-sm', 'd8-u-ls-sm', 'd8-u-text-uppercase', 'text-md', 'd8-u-color-primary')
  }, heading), subheading && !mainTitle && /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-sm', 'd8-u-ls-sm')
  }, subheading), mainTitle && !subheading && /*#__PURE__*/_react["default"].createElement("h5", {
    className: (0, _classnames["default"])('text-md', 'd8-u-ls-sm')
  }, mainTitle)), cta && /*#__PURE__*/_react["default"].createElement("div", {
    className: "link__wrapper margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: cta.id,
    className: cta.className,
    text: cta.text,
    external: cta.external,
    link: cta.link,
    buttonType: cta.buttonType || _constants.BUTTON_TYPES.BARE_NO_PADDING,
    icon: cta.icon,
    iconFlip: cta.iconFlip
  }))) : children));
};
VerticalSplit.propTypes = {
  size: _propTypes["default"].string,
  heading: _propTypes["default"].string,
  subheading: _propTypes["default"].string,
  cta: _propTypes["default"].object,
  title: _propTypes["default"].string,
  image: _propTypes["default"].object,
  mainTitle: _propTypes["default"].string,
  noJustifyEnd: _propTypes["default"].bool,
  titleSize: _propTypes["default"].bool,
  children: _propTypes["default"].any,
  fullHeight: _propTypes["default"].bool,
  inView: _propTypes["default"].bool,
  carouselImages: _propTypes["default"].array,
  pills: _propTypes["default"].array,
  imagePadding: _propTypes["default"].bool,
  video: _propTypes["default"].string,
  gallery: _propTypes["default"].array
};
VerticalSplit.defaultProps = {
  noJustifyEnd: false,
  fullHeight: false,
  size: 'xs'
};
var _default = exports["default"] = VerticalSplit;